import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  actions: {
    justifyContent: 'center',
    '& .MuiButtonBase-root': { minWidth: 140 },
    '& .MuiButton-label': { fontSize: 20 },
  },
}));

export default function DialogContent(props) {
  const classes = useStyles();

  return <div className={classes.actions}>{props.children}</div>;
}
